import { NotificationService } from '@tempots/beatui'

export const Notify = {
  success: (message: string, dismissAfter = 5) => {
    NotificationService.show({ color: 'success', dismissAfter }, message)
  },
  error: (message: string) => {
    NotificationService.show(
      { color: 'danger', icon: 'line-md:cancel-twotone' },
      message
    )
  },
  warn: (message: string, dismissAfter = 10) => {
    NotificationService.show(
      { color: 'warning', icon: 'line-md:construction-twotone', dismissAfter },
      message
    )
  },
  info: (message: string, dismissAfter = 5) => {
    NotificationService.show(
      { color: 'info', icon: 'line-md:loading-twotone-loop', dismissAfter },
      message
    )
  },
}
